// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/number-formatting-radio.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/number-formatting-radio/number-formatting-radio.js';

mount([g0]);
